import React from 'react';
import _ from 'lodash';
import { useCompanyWorkOrders } from 'routes/company/store/actions';

// Components
import { SelectInput } from 'components/forms/form-elements';


export default function WorkOrderSelect({ companyId, ...props }) {
  if (!companyId) return null;

  const { data: workOrders, isLoading } = useCompanyWorkOrders(companyId);

  if (!workOrders) return null;

  const options = _.map(workOrders, workOrder => ({ id: workOrder.id, label: `${workOrder.number} - ${workOrder.description}` }));

  return (
    <SelectInput
      {..._.omit(props, 'dispatch')}
      isLoading={isLoading}
      options={options}
      valueKey="id"
      labelKey="label"
      matchProp="label"
    />
  );
}



// WEBPACK FOOTER //
// ./app/components/forms/selects/work-order-select.js